import StatusOk from "./icons/StatusOk.vue";
import StatusObserve from "./icons/StatusObserve.vue";
import StatusNotOk from "./icons/StatusNotOk.vue";
import StatusBenchmarking from "./icons/StatusBenchmarking.vue";
import Magnify from "./icons/Magnify.vue";
import CloudDownload from "./icons/CloudDownload.vue";
import DropdownArrow from "./icons/DropdownArrow.vue";
import Close from "./icons/Close.vue";
import CheckboxOff from "./icons/CheckboxOff.vue";
import CheckboxOn from "./icons/CheckboxOn.vue";
import CheckboxIndeterminate from "./icons/CheckboxIndeterminate.vue";
import Settings from "./icons/Settings.vue";
import Coordinate from "./icons/Coordinate.vue";
import DepartureArrival from "./icons/DepartureArrival.vue";
import MissingPositionData from "./icons/MissingPositionData.vue";
import Check from "./icons/Check.vue";
import User from "./icons/User.vue";
import HelpCircle from "./icons/HelpCircle.vue";
import Bell from "./icons/Bell.vue";
import BellSettings from "./icons/BellSettings.vue";
import GridPlus from "./icons/GridPlus.vue";
import Home from "./icons/Home.vue";
import DatabaseCheck from "./icons/DatabaseCheck.vue";
import GraphUp from "./icons/GraphUp.vue";
import InfoCircle from "./icons/InfoCircle.vue";
import FastArrowLeft from "./icons/FastArrowLeft.vue";
import DarkMode from "./icons/DarkMode.vue";
import LightMode from "./icons/LightMode.vue";
import XMark from "./icons/XMark.vue";
import RadioCheckOn from "./icons/RadioCheckOn.vue";
import RadioCheckOff from "./icons/RadioCheckOff.vue";
import SeaWaves from "./icons/SeaWaves.vue";
import Office from "./icons/Office.vue";
import Edit from "./icons/Edit.vue";
import Delete from "./icons/Delete.vue";
import ArrowUp from "./icons/ArrowUp.vue";
import ArrowDown from "./icons/ArrowDown.vue";
import Reports from "./icons/Reports.vue";
import Filter from "./icons/Filter.vue";
import WarningCircle from "./icons/WarningCircle.vue";
import Plus from "./icons/Plus.vue";
import XMarkCircle from "./icons/XMarkCircle.vue";
import CheckCircle from "./icons/CheckCircle.vue";
import RCircle from "./icons/RCircle.vue";
import ECircle from "./icons/ECircle.vue";
import ArrowUpCircle from "./icons/ArrowUpCircle.vue";
import ArrowDownCircle from "./icons/ArrowDownCircle.vue";
import RefreshCircle from "./icons/RefreshCircle.vue";
import Calendar from "./icons/Calendar.vue";
import Flash from "./icons/Flash.vue";
import ArrowLeft from "./icons/ArrowLeft.vue";
import Mail from "./icons/Mail.vue";
import FolderPlus from "./icons/FolderPlus.vue";
import Eye from "./icons/Eye.vue";
import EyeClosed from "./icons/EyeClosed.vue";
import Play from "./icons/Play.vue";
import Pause from "./icons/Pause.vue";
import Archive from "./icons/Archive.vue";
import Key from "./icons/Key.vue";
import Copy from "./icons/Copy.vue";
import DataTransferDown from "./icons/DataTransferDown.vue";
import ReportsSolid from "./icons/ReportsSolid.vue";

export default {
  values: {
    StatusOk: { component: StatusOk },
    StatusObserve: { component: StatusObserve },
    StatusNotOk: { component: StatusNotOk },
    StatusBenchmarking: { component: StatusBenchmarking },
    Magnify: { component: Magnify },
    CloudDownload: { component: CloudDownload },
    DropdownArrow: { component: DropdownArrow },
    test: { component: DropdownArrow },
    Close: { component: Close },
    CheckboxOff: { component: CheckboxOff },
    CheckboxOn: { component: CheckboxOn },
    CheckboxIndeterminate: { component: CheckboxIndeterminate },
    Settings: { component: Settings },
    Coordinate: { component: Coordinate },
    DepartureArrival: { component: DepartureArrival },
    MissingPositionData: { component: MissingPositionData },
    Check: { component: Check },
    User: { component: User },
    HelpCircle: { component: HelpCircle },
    Bell: { component: Bell },
    BellSettings: { component: BellSettings },
    GridPlus: { component: GridPlus },
    Home: { component: Home },
    DatabaseCheck: { component: DatabaseCheck },
    GraphUp: { component: GraphUp },
    InfoCircle: { component: InfoCircle },
    FastArrowLeft: { component: FastArrowLeft },
    DarkMode: { component: DarkMode },
    LightMode: { component: LightMode },
    XMark: { component: XMark },
    RadioCheckOn: { component: RadioCheckOn },
    RadioCheckOff: { component: RadioCheckOff },
    SeaWaves: { component: SeaWaves },
    Office: { component: Office },
    Edit: { component: Edit },
    Delete: { component: Delete },
    ArrowUp: { component: ArrowUp },
    ArrowDown: { component: ArrowDown },
    Reports: { component: Reports },
    Filter: { component: Filter },
    WarningCircle: { component: WarningCircle },
    Plus: { component: Plus },
    XMarkCircle: { component: XMarkCircle },
    CheckCircle: { component: CheckCircle },
    RCircle: { component: RCircle },
    ECircle: { component: ECircle },
    ArrowUpCircle: { component: ArrowUpCircle },
    ArrowDownCircle: { component: ArrowDownCircle },
    RefreshCircle: { component: RefreshCircle },
    Calendar: { component: Calendar },
    Flash: { component: Flash },
    ArrowLeft: { component: ArrowLeft },
    Mail: { component: Mail },
    FolderPlus: { component: FolderPlus },
    Eye: { component: Eye },
    EyeClosed: { component: EyeClosed },
    Play: { component: Play },
    Pause: { component: Pause },
    Archive: { component: Archive },
    Key: { component: Key },
    Copy: { component: Copy },
    DataTransferDown: { component: DataTransferDown },
    ReportsSolid: { component: ReportsSolid },
  }
}
